// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TopBarPageInnerTitle-base__z4t20{display:flex;gap:var(--size-3);align-items:center;min-width:0;color:var(--gray-12)}.TopBarPageInnerTitle-label__4NnOR{max-width:var(--size-full);overflow:hidden;color:var(--gray-12);white-space:nowrap;text-overflow:ellipsis;font:var(--font-body-500-compact);font-feature-settings:var(--feature-settings-body-500-compact);letter-spacing:var(--letter-spacing-body-500-compact)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "TopBarPageInnerTitle-base__z4t20",
	"label": "TopBarPageInnerTitle-label__4NnOR"
};
export default ___CSS_LOADER_EXPORT___;
